import { ToastPosition} from "react-toastify";

export const toastOptions = {
    position: 'top-right' as  ToastPosition,
    draggable: true,
    pauseOnHover: true,
    autoClose: 4000,
    theme: 'light',
}
